export const addCustomCssVars = (styleId, cssVars) => {
	const headTag = document.getElementsByTagName('head')[0];
	const headStyleTagExist = document.getElementById(styleId)
	const styleTag = headStyleTagExist ? headStyleTagExist : document.createElement("style");

	styleTag.id = styleId
	let cssString = ''

	Object.keys(cssVars).map(varKey => {
		const value = cssVars[varKey]

		cssString = cssString + varKey + ":" + value + ";"
	})

	styleTag.innerHTML = `
		:root {
		${cssString}
		}
	`;

	headTag.appendChild(styleTag);
}